import Cookies from "js-cookie";
import { adminAxios } from "../api/index"; // Import admin axios instance

export const GetAllCompany = (data) => {
  let companyUrl;
  companyUrl = `Company/all`;
  try {
    const response = adminAxios.get(companyUrl, {
       params: {
        ...(data && { search: data }),
      },
      headers: {
        Authorization: `Bearer ${Cookies.get("userToken")}`,
      },
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const CreateCompanyAPI = (data) => {
  const CreateCompanyURL = "Company/create";
  try {
    const response = adminAxios.post(CreateCompanyURL, data, {
      headers: {
        Authorization: `Bearer ${Cookies.get("userToken")}`,
      },
    });
    return response;
  } catch (err) {
    return err;
  }
};

export const UpdateCompanyAPI = async (data, companyId) => {
  if (!companyId) return;
  const UpdateCompanyURL = `company/update/${companyId}`;
  try {
    const response = await adminAxios.put(UpdateCompanyURL, data, {
      headers: {
        Authorization: `Bearer ${Cookies.get("userToken")}`,
      },
    });
    return response;
  } catch (err) {
    return err;
  }
};